export const environment = {
  production: false,
  teamViewerUrl: "https://get.teamviewer.com/68m3xdh"
};
